import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostPhysicalDistributionTemplate } from 'services/templates/physical-distribution-template';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreatePhysicalDistributionSectionTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createPhysicalDistribution = usePostPhysicalDistributionTemplate();

  const goBackToContractTemplate = () => navigate('/templates-extended');

  const onCreatePhysicalDistributionSection = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const distribution = middleware.template.physicalDistribution.formToQuery(values);

    if (distribution) {
      await createPhysicalDistribution.mutateAsync(distribution, {
        onSuccess: id => navigate(`/templates-extended/physical-distribution/${id}/form`),
        onError: error => onErrorShowAllErrorsToast(error),
      });
    }
  };

  return (
    <Form.Contract
      tittle={t('contract-template.physicalDistribution.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t(`button.create`)} />
        </Button>
      }
      initialStatus={contractTemplateUtil.distribution.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: contractTemplateUtil.distribution.initialValues(TEMPLATE_TYPE.physicalDistribution),
      }}
      onSubmit={onCreatePhysicalDistributionSection}
    />
  );
};

export default CreatePhysicalDistributionSectionTemplate;
